import './custom/header-search'
import './custom/hero-search'
import './custom/infotrack'
import './custom/skip-to-content'
import './custom/social-share'
import './custom/tooltip'
import './custom/articles-slider'
import './custom/match-height'

// Init menu
import NavBar from './custom/navbar'
const navbar = new NavBar();

// Init anchor nav
import AnchorNav from './custom/anchor-nav'
const anchorNav = new AnchorNav(".js-anchorNav");

// Init publications
import Alpine from 'alpinejs'
import publicationFilter from './blocks/publications'

// filter for publications block, all logic is in blocks/publications.js
Alpine.data('publicationFilter', publicationFilter)

window.Alpine = Alpine
Alpine.start()
